import { render, staticRenderFns } from "./MarketPrice.vue?vue&type=template&id=302d1489"
import script from "./MarketPrice.vue?vue&type=script&lang=js"
export * from "./MarketPrice.vue?vue&type=script&lang=js"
import style0 from "./MarketPrice.vue?vue&type=style&index=0&id=302d1489&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports